import { join, map } from "fxjs/es";
import { CommonNS } from "../../../../Common/CommonNS.js";
import { DATA_KEY_STROKE_DASHARRAY, DATA_KEY_STROKE_WIDTH } from "./const.js";
export class Stroke {
  constructor({ svg_el, getCTM }) {
    this._svg_el = svg_el;
    this._getCTM = getCTM;
  }
  setStrokeWidth({ el, stroke_width }) {
    const non_scaling_stroke_width =
      this._calculateNonScalingLength(stroke_width);
    el.dataset[DATA_KEY_STROKE_WIDTH] = `${stroke_width}`;
    el.setAttributeNS(null, "vector-effect", "non-scaling-stroke");
    el.setAttributeNS(null, "stroke-width", `${non_scaling_stroke_width}`);
  }
  syncStrokeWidth(el) {
    const stroke_width = el.dataset[DATA_KEY_STROKE_WIDTH];
    if (!stroke_width) {
      return;
    }
    this.setStrokeWidth({
      el,
      stroke_width: Number(stroke_width),
    });
  }
  setStrokeDasharray({ el, stroke_dasharray }) {
    const non_scaling_stroke_dasharray = map((n) =>
      this._calculateNonScalingLength(n)
    )(stroke_dasharray);
    el.dataset[DATA_KEY_STROKE_DASHARRAY] = JSON.stringify(stroke_dasharray);
    el.setAttributeNS(null, "vector-effect", "non-scaling-stroke");
    el.setAttributeNS(
      null,
      "stroke-dasharray",
      join(" ")(non_scaling_stroke_dasharray)
    );
  }
  syncStrokeDasharray(el) {
    const stroke_dasharray = el.dataset[DATA_KEY_STROKE_DASHARRAY];
    if (!stroke_dasharray) {
      return;
    }
    this.setStrokeDasharray({
      el,
      stroke_dasharray: JSON.parse(stroke_dasharray),
    });
  }
  _calculateNonScalingLength(length) {
    const ctm = this._getCTM();
    const point1 = CommonNS.UtilNS.createSVGPoint(this._svg_el)([
      0, 0,
    ]).matrixTransform(ctm);
    const point2 = CommonNS.UtilNS.createSVGPoint(this._svg_el)([
      length,
      0,
    ]).matrixTransform(ctm);
    return Math.sqrt(
      Math.abs(point1.x - point2.x) ** 2 + Math.abs(point1.y - point2.y) ** 2
    );
  }
}
